import * as React from 'react'

import {noop} from '../../../utils/empty'

type ShowPopupAction = {
  itemKey: string
  show: boolean
}
type ShowPopupContextType = [string | null, (action: ShowPopupAction) => unknown]
const ShowPopupContext = React.createContext<ShowPopupContextType>([null, noop])
type ShowPopupProviderProps = {
  children: React.ReactNode
}
export function ShowPopupProvider({children}: ShowPopupProviderProps) {
  const [shownPopupKey, setShowPopup] = React.useReducer(
    (state: string | null, {itemKey, show}: ShowPopupAction) => {
      if (show) {
        return itemKey
      }

      if (itemKey === state) {
        return null
      }

      return state
    },
    null,
  )
  const contextValue: ShowPopupContextType = React.useMemo(
    () => [shownPopupKey, setShowPopup],
    [shownPopupKey],
  )
  return <ShowPopupContext.Provider value={contextValue}>{children}</ShowPopupContext.Provider>
}
export function useShowPopup(itemKey: string): [boolean, (arg0: boolean) => unknown] {
  const [shownPopupKey, setShowPopup] = React.useContext(ShowPopupContext)
  return [
    shownPopupKey === itemKey,
    React.useCallback(
      show =>
        setShowPopup({
          itemKey,
          show,
        }),
      [itemKey, setShowPopup],
    ),
  ]
}
